import type { InsuranceIndex } from '../../../types/InsuranceFeatureConfig';
import type { LiabilityFeatureConfig } from '../../../types/insurances/LiabilityFeatureConfig';
import { liability as base } from './base';
import { liability as CZ } from './CZ';

export const liabilityConfig: InsuranceIndex<LiabilityFeatureConfig> = { base, CZ };
